import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';

@Component({
    selector: 'app-contactus-paragraph',
    templateUrl: './contactus-paragraph.component.html',
    styleUrl: './contactus-paragraph.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ContactusParagraphComponent {

  public componentData: CmsParagraphComponent;

  constructor(public component: CmsComponentData<CmsParagraphComponent>) { }

  ngOnInit(): void {
    this.component.data$.subscribe((data) => {
      this.componentData = data;
    });
  }
}
